import { ChevronLeftIcon, InfoOutlineIcon } from "@chakra-ui/icons";
import {
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  HStack,
  IconButton,
  Input,
  ListItem,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Text,
  Tooltip,
  UnorderedList,
  useDisclosure,
  VStack
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import { useContext, useEffect, useState } from "react";
import { HiOutlineRefresh } from "react-icons/hi";
import { IoIosSend } from "react-icons/io";
import { appRequest } from "routes";
import { formatDate } from "utils/dateUtils/dateUtils";

export default function ChatBox({
  setIssueData,
  issueData,
  messages,
  handleSubmitMessage,
  inputValue,
  handleChange,
  handleKeyDown,
  fetchChats,
  lastMessageRef,
  fetchQueries,
}: any) {
  const { accountDetails, toastNotify } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [issueDetails, setIssueDetails] = useState<any>(null);

  const getIssueDeatils = async () => {
    try {
      const issueId = issueData?._id;

      const response: any = await appRequest("issues", "getIssueDeatilsBuyer", {
        issueId,
      });
      if (response.status === "success") {
        setIssueDetails(response?.issue || null);
        console.log("issueDetails response", response?.issue);
      }
    } catch (error: any) {
      console.error("Error fetching issueDetails:", error);
    }
  };

  useEffect(() => {
    getIssueDeatils();
  }, []);

  console.log("issueData in chatbox", issueData)

  useEffect(() => {
    if (lastMessageRef?.current) {
      lastMessageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, lastMessageRef]);

  console.log("messages in chatbox", messages)


  const handleIssueStatusUpdate = async (issue: any, newStatus: any) => {
    try {
      setLoading(true);
      const response: any = await appRequest("queries", "updateQueryStatus", {
        queryId: issue._id,
        status: newStatus,
      });

      if (response.status === "success") {
        toastNotify({
          title: "Status updated successfully",
          type: "success",
        });
        fetchQueries();
      } else {
        toastNotify({
          title: "Error updating status",
          type: "error",
        });
      }
    } catch (error: any) {
      console.log("error", error.message);
    } finally {
      setLoading(false);
      fetchQueries();
    }
  };

  return (
    <Box rounded="lg" mx="auto">
      <Box bg="teal.600" p={2} rounded="lg" boxShadow="sm" color="white">
        <Flex justify="space-between" align="center">
          <Flex gap={{ base: 1, md: 3 }} align="center">
            <IconButton
              aria-label="back"
              icon={<ChevronLeftIcon fontSize="24px" />}
              // onClick={() => setIssueData(null)}
              size={{ base: "sm", md: "md" }}
              colorScheme="whiteAlpha"
              variant="ghost"
            />
            <Box>
              <Text
                textTransform={"capitalize"}
                fontSize={{ base: "sm", md: "lg" }}
                fontWeight="bold"
              >
                {issueDetails?.user?.name}
              </Text>
              <Text fontSize="xs" color="teal.100" mt={-0.5}>
                {messages[0]?.sender}
              </Text>
            </Box>
            <Popover placement="bottom">
              <PopoverTrigger>
                <IconButton
                  aria-label="info"
                  icon={<InfoOutlineIcon fontSize="20px" />}
                  size={{ base: "sm", md: "md" }}
                  colorScheme="whiteAlpha"
                  isRound
                  variant="ghost"
                />
              </PopoverTrigger>
              {/* <Portal> */}
              <PopoverContent
                width="100%"
                bg={"white"}
                color={"gray.700"}
                border={"1px solid"}
                borderColor={"gray.400"}
                maxW={"lg"}
                minW={"lg"}
                ml={2}
                mt={1}
              >
                <PopoverArrow />
                <PopoverCloseButton />
                <PopoverHeader fontWeight="bold">Query Details</PopoverHeader>
                <PopoverBody
                  p={4}
                  shadow={"xl"}
                  maxH={"20rem"}
                  overflow={"auto"}
                  className="customScrollBarHidden"
                >
                  <VStack align="start" spacing={2}>
                    <HStack align={"baseline"} spacing={2}>
                      <Text fontSize="md" fontWeight="bold">
                        Subject:
                      </Text>
                      <Text fontSize="sm">{issueDetails?.short_desc}</Text>
                    </HStack>

                    <Divider />

                    <HStack align={"baseline"} spacing={2}>
                      <Text fontSize="md" fontWeight="bold">
                        Description:
                      </Text>
                      <Text fontSize="sm" whiteSpace="pre-wrap">
                        {issueDetails?.long_desc}
                      </Text>
                    </HStack>

                    <Divider />

                    <HStack align={"baseline"} spacing={2}>
                      <Text fontSize="md" fontWeight="bold">
                        Issue Type:
                      </Text>
                      <Text textTransform={"capitalize"} fontSize="sm">
                        {issueDetails?.category?.label || "NA"}
                      </Text>
                    </HStack>

                    <Divider />
                    <HStack align={"baseline"} spacing={2}>
                      <Text fontSize="md" fontWeight="bold">
                        {issueDetails?.category?.label === "reconciliation"
                          ? "QR Ticket Id's:"
                          : "Order Id's:"}
                      </Text>

                      <UnorderedList>
                        {issueDetails?.ids?.map((id: any, index: number) => (
                          <ListItem key={index} fontSize="sm">
                            {id}
                          </ListItem>
                        ))}
                        {issueDetails?.category?.label !== "reconciliation" && (
                          <ListItem fontSize="sm">
                            {issueDetails?.order?._id}
                          </ListItem>
                        )}
                      </UnorderedList>
                    </HStack>
                  </VStack>
                </PopoverBody>
              </PopoverContent>
              {/* </Portal> */}
            </Popover>
          </Flex>
          <Flex gap={2} align="center">
            <VStack align="end" spacing={1}>
              <Badge
                colorScheme={issueDetails?.status === "open" ? "green" : "red"}
                variant="solid"
                rounded="md"
                fontSize="0.8em"
              >
                {issueDetails?.status}
              </Badge>
              <Text fontSize="xs" textAlign={'end'} color="gray.200">
                Created: {formatDate(issueDetails?.createdAt)}
              </Text>
            </VStack>
            <Tooltip label="Refresh Chat">
              <IconButton
                aria-label="refresh"
                colorScheme="whiteAlpha"
                size={{ base: "sm", md: "md" }}
                variant="ghost"
                icon={<HiOutlineRefresh />}
                onClick={() => fetchChats(issueDetails?._id)}
              />
            </Tooltip>
          </Flex>
        </Flex>
      </Box>

      <Flex
        my={{ base: 2, md: 4 }}
        flexDir="column"
        p={2}
        rounded="md"
        border="1px solid"
        borderColor="teal.300"
        bg="white"
        justifyContent="flex-end"
      >
        <Box
          className="customScrollBarHidden"
          maxH="50vh"
          minH={{ base: "36vh", lg: "50vh" }}
          overflowY="auto"
        >
          {messages.map((message: any, index: number) => {
            const isCurrentBuyer = message?.sender === "buyer";
            return (
              <Flex
                my={1}
                key={index}
                justify={isCurrentBuyer ? "flex-end" : "flex-start"}
                align={"center"}
                gap={1}
              >
                <Box
                  bg={isCurrentBuyer ? "green.200" : "blue.50"}
                  color="gray.700"
                  rounded="md"
                  mr={2}
                  px={2}
                  py={1}
                  boxShadow="md"
                  maxW={{ base: "70%", lg: "40%" }}
                  ref={index === messages.length - 1 ? lastMessageRef : null}
                >
                  <Text fontSize={{ base: "xs", md: "sm" }} fontWeight="medium">
                    {message?.message}
                  </Text>
                </Box>
              </Flex>
            );
          })}
        </Box>
      </Flex>
      {issueDetails?.status !== "closed" && (
        <Flex
          mt={1}
          alignItems="center"
          p={2}
          bg="white"
          rounded="md"
          boxShadow="md"
          border="1px solid"
          borderColor="gray.200"
        >
          <FormControl id="issue" isRequired>
            <Input
              placeholder="Type your message..."
              value={inputValue}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              variant="filled"
              bg="gray.100"
              _hover={{ bg: "gray.200" }}
            />
          </FormControl>
          <IconButton
            aria-label="Send issue"
            icon={<IoIosSend />}
            colorScheme="teal"
            onClick={handleSubmitMessage}
            ml={2}
          />
        </Flex>
      )}

      {issueDetails?.user?._id === accountDetails?._id && (
        <Flex justify="end" mt={4}>
          {issueDetails.status !== "closed" && (
            <Button
              size="sm"
              colorScheme="yellow"
              onClick={() => handleIssueStatusUpdate(issueDetails, "closed")}
            >
              Close The Query
            </Button>
          )}
        </Flex>
      )}
    </Box>
  );
}
